import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";

import { SharedModule } from "../shared/shared.module";
import { ChartsPageModule } from "../charts-page/charts-page.module";
import { IconsModule } from "@va/core-library/icons";
import { IndustryMegaMenuComponent } from "./industry-mega-menu/industry-mega-menu.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CompsPageModule } from "../comps-page/comps-page.module";
import { IndustryPageChartSectionComponent } from "./industry-page-chart-section/industry-page-chart-section.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { PeriodFilterModule } from "@va/core-library/period-filter";
import { IndustryContentComponent } from "./industry-content/industry-content.component";
import { IndustryValuationComponent } from "./industry-valuation/industry-valuation.component";
import { IndustryRevisionComponent } from "./industry-revision/industry-revision.component";
import { INDUSTRY_PAGE_INFO } from "./sector-and-industry-page-constants";
import { ValuationPageModule } from "src/app/valuation-page/valuation-page.module";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { IndustryGeographyFilterComponent } from "./industry-geography-filter/industry-geography-filter.component";
import { IndustryMarketCapFilterComponent } from "./industry-market-cap-filter/industry-market-cap-filter.component";
import { ClusterFilterComponent } from "./cluster-filter/cluster-filter.component";
import { NoTickerPopupComponent } from "./no-ticker-popup/no-ticker-popup.component";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzModalModule } from "ng-zorro-antd/modal";
import { ButtonModule } from "@va/core-library/button";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";

const industryAnalysisRoutes: Routes = [
  {
    path: "",
    redirectTo: "166/kpis",
    pathMatch: "full",
  },
  {
    path: ":industryId",
    redirectTo: ":industryId/kpis",
  },
  {
    path: ":industryId/kpis",
    component: IndustryContentComponent,
    data: {
      title: "Industry Analysis, KPI's",
      shortName: INDUSTRY_PAGE_INFO.kpis.shortName,
    },
  },
  {
    path: ":industryId/valuation",
    component: IndustryValuationComponent,
    data: {
      title: "Industry Analysis, Valuation",
      shortName: INDUSTRY_PAGE_INFO.valuation.shortName,
    },
  },
  {
    path: ":industryId/revisionanalysis",
    component: IndustryRevisionComponent,
    data: {
      title: "Industry Analysis, Revision Analysis",
      shortName: INDUSTRY_PAGE_INFO.revisionanalysis.shortName,
    },
  },
  {
    path: ":industryId/surpriseanalysis",
    component: IndustryRevisionComponent,
    data: {
      title: "Industry Analysis, Surprise Analysis",
      shortName: INDUSTRY_PAGE_INFO.surpriseanalysis.shortName,
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];
@NgModule({
  imports: [RouterModule.forChild(industryAnalysisRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class IndustryAnalysisPageRoutingModule {}
@NgModule({
  declarations: [
    IndustryMegaMenuComponent,
    IndustryPageChartSectionComponent,
    IndustryContentComponent,
    IndustryValuationComponent,
    IndustryRevisionComponent,
    IndustryGeographyFilterComponent,
    IndustryMarketCapFilterComponent,
    ClusterFilterComponent,
    NoTickerPopupComponent,
  ],
  imports: [
    IndustryAnalysisPageRoutingModule,
    CommonModule,
    ButtonModule,
    SharedModule,
    ChartsPageModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    CompsPageModule,
    ChartPlotterModule,
    PeriodFilterModule,
    ValuationPageModule,
    CurrencySelectModule,
    NzSkeletonModule,
    NzRadioModule,
    NzCheckboxModule,
    NzTreeModule,
    NzPopoverModule,
    NzIconModule,
    NzSpinModule,
    NzGridModule,
    NzModalModule,
    NzToolTipModule,
  ],
  exports: [IndustryMegaMenuComponent],
})
export class IndustryAnalysisPageModule {}
